import * as _ from "lodash";

export class Integration {
    public key: string | undefined;
    public title: string | undefined;
    public settings: any;

    public status = "Active";
    public error = false;
    public progress = 0;

    public installed?: boolean;
    public available?: boolean;

    constructor(data?: object) {
        if (data) {
            this.setData(data);
        }
    }

    setData(data: object): void {
        _.merge(this, data);
    }

    update(progress: number, data?: object): void {
        if (data) {
            _.merge(this, data);
        }
        this.setProgress(progress);
    }

    setProgress(newProgress?: number): void {
        if (!newProgress) return;

        this.progress = Math.round(newProgress);
    }

    isComplete(): boolean {
        return this.progress == 100;
    }

    isError(): boolean {
        return this.error;
    }

    setError(): void {
        this.status = "Error";
        this.error = true;
        this.progress = 0;
    }

    reset(): void {
        this.status = "Active";
        this.error = false;
        this.progress = 0;
    }
}
